import { Calendar, Music, User, Utensils } from 'lucide-react';

const upcomingEvents = [
  {
    id: 1,
    title: 'Večer žive glasbe',
    date: '15. junij 2023',
    time: '20:00',
    description: 'Lokalni glasbenik bo ustvaril prijetno vzdušje ob koncu tedna.',
    imageSrc: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    category: 'Glasba',
    icon: Music,
  },
  {
    id: 2,
    title: 'Degustacija craft piv',
    date: '22. junij 2023',
    time: '18:00',
    description: 'Spoznajte različna lokalna craft piva z našim strokovnjakom.',
    imageSrc: 'https://images.unsplash.com/photo-1535359056830-d4badde79747?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    category: 'Degustacija',
    icon: Utensils,
  },
  {
    id: 3,
    title: 'Tematski večer: Balkanski žar',
    date: '29. junij 2023',
    time: '19:00',
    description: 'Posebna ponudba balkanskih specialitet z žara in tradicionalna glasba.',
    imageSrc: 'https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    category: 'Tematski večer',
    icon: Utensils,
  },
];

const Events = () => {
  return (
    <section className="section-container bg-muted" id="events">
      <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
        <div className="inline-flex items-center space-x-2 mb-4">
          <div className="h-px w-8 bg-barbecue-500"></div>
          <span className="text-barbecue-500 font-medium">DOGODKI</span>
          <div className="h-px w-8 bg-barbecue-500"></div>
        </div>
        <h2 className="heading-lg mb-4">Prihajajoči dogodki</h2>
        <p className="paragraph">
          Pridružite se nam na posebnih večerih z živo glasbo, degustacijah in tematskih dogodkih.
          Vedno se pri nas nekaj dogaja!
        </p>
      </div>

      {/* Events List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {upcomingEvents.map((event) => (
          <div key={event.id} className="card overflow-hidden transform transition-all duration-300 hover:translate-y-[-5px] animate-fade-in">
            <div className="relative h-48">
              <img 
                src={event.imageSrc} 
                alt={event.title} 
                className="w-full h-full object-cover" 
              />
              <div className="absolute top-4 right-4 bg-barbecue-600 text-white text-xs font-medium px-3 py-1 rounded-full">
                {event.category}
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center mb-4">
                <Calendar className="w-5 h-5 text-barbecue-500 mr-2" />
                <span className="text-sm text-foreground/70">{event.date} ob {event.time}</span>
              </div>
              <h3 className="heading-sm mb-2">{event.title}</h3>
              <p className="text-foreground/80 mb-4">{event.description}</p>
              <button className="btn-outline !px-4 !py-2 !text-sm w-full">
                Rezerviraj mesto
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Private Events */}
      <div className="mt-16 glass-card p-8 md:p-12 animate-fade-in">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-2/3 md:pr-8 mb-6 md:mb-0">
            <h3 className="heading-md mb-4">Organizirajte vaš zasebni dogodek pri nas</h3>
            <p className="paragraph mb-6">
              Praznujte rojstni dan, obletnico ali poslovni uspeh v našem prijetnem ambientu.
              Pripravimo meni po vaših željah in poskrbimo za nepozabno doživetje.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="flex items-center">
                <User className="w-5 h-5 text-barbecue-500 mr-2" />
                <span className="text-sm">Do 50 oseb</span>
              </div>
              <div className="flex items-center">
                <Utensils className="w-5 h-5 text-barbecue-500 mr-2" />
                <span className="text-sm">Po meri prilagojen meni</span>
              </div>
              <div className="flex items-center">
                <Music className="w-5 h-5 text-barbecue-500 mr-2" />
                <span className="text-sm">Možnost glasbe</span>
              </div>
            </div>
            <button className="btn-secondary">
              Pošljite povpraševanje
            </button>
          </div>
          <div className="md:w-1/3">
            <img 
              src="https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Zasebni dogodek" 
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;